import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import { auth, idle, signalr, Custom } from '@/f1/service';
import DefaultAside from '../DefaultAside'
import DefaultHeaderDropdownAccnt from '../DefaultHeaderDropdownAccnt'
import * as _ from 'lodash'
import config from '@/f1/config'
import Language from './language';

const _i18n_data = {
  username: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};

const WMDS =
{ name: 'WMDS', url: '/wmds', icon: 'fas fa-list-alt', permissions: ['owner', 'user', 'monitor'], children :
  [
    { name: 'ㄴ Site List', url: '/wmds/site' },
    { name: 'ㄴ Pattern', url: '/wmds/pattern' },
    { name: 'ㄴ Detect', url: '/wmds/detect' },
    { name: 'ㄴ Result', url: '/wmds/result' },
    { name: 'ㄴ Schedule', url: '/wmds/schedule' },
    { name: 'ㄴ Policy', url: '/wmds/policy' },
  ]
}

const WSFinder =
{ name: 'WSFinder', url: '/wsfinder', icon: 'fas fa-table', permissions: ['owner', 'user', 'monitor'], children :
  [
    { name: 'ㄴ Agent', url: '/wsfinder/agent' },
    { name: 'ㄴ Detect', url: '/wsfinder/detect' },
    { name: 'ㄴ Result', url: '/wsfinder/result' },
    { name: 'ㄴ Exception', url: '/wsfinder/hash' },
    { name: 'ㄴ Analysis request', url: '/wsfinder/report' },
    { name: 'ㄴ Pattern', url: '/wsfinder/pattern' },
  ]
}

const WEBCastle =
{ name: 'WEBCastle', url: '/webcastle', icon: 'fas fa-paste', permissions: ['owner', 'user', 'monitor'], children :
  [
    { name: 'ㄴ WebServer', url: '/webcastle/modules' },
    { name: 'ㄴ Castle Log', url: '/webcastle/log' },
    // { name: 'ㄴ Multiplexing', url: '/webcastle/multiplexing' },
  ]
}

const WFDetector =
{ name: 'WFDetector', url: '/integrity', icon: 'fas fa-th-list', permissions: ['owner', 'user', 'monitor'], children :
  [
    { name: 'ㄴ Main', url: '/integrity/main', permissions: ['owner', 'monitor', 'user'] },
    { name: 'ㄴ WSFinder', url: '/integrity/wsfinder', permissions: ['owner', 'monitor', 'user'] },
    { name: 'ㄴ WMDS', url: '/integrity/wmds', permissions: ['owner', 'monitor', 'user'] },
    { name: 'ㄴ Detect', url: '/integrity/detect', permissions: ['owner', 'monitor', 'user'] },
  ]
}

const OwnerManage =  [
  { name: 'Manage', title : true, permissions: ['owner', 'billing'] },
  { name: 'Group Info', url: '/group', icon: 'fas fa-users', permissions: ['owner'] },
  { name: 'User Manage', url: '/user', icon: 'fas fa-user', permissions: ['owner'] },
  { name: 'Billing', url: '/billing', icon: 'fa fa-credit-card-alt', permissions: ['owner', 'billing'] },
]

let BaseManage = [
  { name: 'Summary', title : true, permissions: ['owner', 'user', 'monitor'] },
  { name: 'Downloads', url: '/downloads', icon: 'fas fa-download', permissions: ['owner', 'user'] },
  { name: 'Dashboard', url: '/welcome', icon: 'fas fa-chart-line', permissions: ['owner', 'user', 'monitor'] },
  { name: 'Report', url : '/report', icon: 'fas fa-clipboard', permissions: ['owner', 'user', 'monitor'] },
]

const Board = [
  { name: 'Boards', title : true, permissions: ['owner', 'user', 'monitor'] },
  { name: 'Q&A', url: '/boards/qna', icon: 'fas fa-question-circle', permissions: ['owner', 'user', 'monitor'] },
  { name: 'FAQ', url: '/boards/faq', icon: 'fas fa-filter', permissions: ['owner', 'user', 'monitor'] },
  { name: 'Notice', url: '/boards/notice', icon: 'fas fa-bell', permissions: ['owner', 'user', 'monitor'] },
]

const Profile = [
  { name: 'My Info.', title : true , permissions: ['owner', 'user', 'monitor', 'billing']},
  { name: 'Profile', url: '/profile', icon: 'far fa-address-card', permissions: ['owner', 'user', 'monitor', 'billing'] },
  { name: 'Logout', url: '/logout', icon: 'fas fa-sign-out-alt', permissions: ['owner', 'user', 'monitor', 'billing'] },
]

const WMDS_ko =
{ name: 'WMDS', url: '/wmds', icon: 'fas fa-list-alt', permissions: ['owner', 'user', 'monitor'], children :
  [
    { name: 'ㄴ 사이트', url: '/wmds/site' },
    { name: 'ㄴ 패턴', url: '/wmds/pattern' },
    { name: 'ㄴ 탐지', url: '/wmds/detect' },
    { name: 'ㄴ 결과', url: '/wmds/result' },
    { name: 'ㄴ 일정', url: '/wmds/schedule' },
    { name: 'ㄴ 정책', url: '/wmds/policy' },
  ]
}

const WSFinder_ko =
{ name: 'WSFinder', url: '/wsfinder', icon: 'fas fa-table', permissions: ['owner', 'user', 'monitor'], children :
  [
    { name: 'ㄴ 에이전트', url: '/wsfinder/agent' },
    { name: 'ㄴ 탐지', url: '/wsfinder/detect' },
    { name: 'ㄴ 결과', url: '/wsfinder/result' },
    { name: 'ㄴ 예외처리', url: '/wsfinder/hash' },
    { name: 'ㄴ 분석요청', url: '/wsfinder/report' },
    { name: 'ㄴ 패턴', url: '/wsfinder/pattern' },
  ]
}

const WEBCastle_ko =
{ name: 'WEBCastle', url: '/webcastle', icon: 'fas fa-paste', permissions: ['owner', 'user', 'monitor'], children :
  [
    { name: 'ㄴ 웹서버', url: '/webcastle/modules' },
    { name: 'ㄴ 로그', url: '/webcastle/log' },
    // { name: 'ㄴ Multiplexing', url: '/webcastle/multiplexing' },
  ]
}

const WFDetector_ko =
{ name: 'WFDetector', url: '/integrity', icon: 'fas fa-th-list', permissions: ['owner', 'user', 'monitor'], children :
  [
    { name: 'ㄴ 메인', url: '/integrity/main', permissions: ['owner', 'monitor', 'user'] },
    { name: 'ㄴ WSFinder', url: '/integrity/wsfinder', permissions: ['owner', 'monitor', 'user'] },
    { name: 'ㄴ WMDS', url: '/integrity/wmds', permissions: ['owner', 'monitor', 'user'] },
    { name: 'ㄴ 탐지', url: '/integrity/detect', permissions: ['owner', 'monitor', 'user'] },
  ]
}

const OwnerManage_ko =  [
  { name: '관리', title : true, permissions: ['owner', 'billing'] },
  { name: '그룹정보', url: '/group', icon: 'fas fa-users', permissions: ['owner'] },
  { name: '사용자관리', url: '/user', icon: 'fas fa-user', permissions: ['owner'] },
  { name: '요금', url: '/billing', icon: 'fa fa-credit-card-alt', permissions: ['owner', 'billing'] },
]

let BaseManage_ko = [
  { name: '요약', title : true, permissions: ['owner', 'user', 'monitor'] },
  { name: '다운로드', url: '/downloads', icon: 'fas fa-download', permissions: ['owner', 'user'] },
  { name: '상황판', url: '/welcome', icon: 'fas fa-chart-line', permissions: ['owner', 'user', 'monitor'] },
  { name: '보고서', url : '/report', icon: 'fas fa-clipboard', permissions: ['owner', 'user', 'monitor'] },
]

const Board_ko = [
  { name: '게시판', title : true, permissions: ['owner', 'user', 'monitor'] },
  { name: 'Q&A', url: '/boards/qna', icon: 'fas fa-question-circle', permissions: ['owner', 'user', 'monitor'] },
  { name: 'FAQ', url: '/boards/faq', icon: 'fas fa-filter', permissions: ['owner', 'user', 'monitor'] },
  { name: '공지사항', url: '/boards/notice', icon: 'fas fa-bell', permissions: ['owner', 'user', 'monitor'] },
]

const Profile_ko = [
  { name: '내 정보', title : true , permissions: ['owner', 'user', 'monitor', 'billing']},
  { name: '프로필', url: '/profile', icon: 'far fa-address-card', permissions: ['owner', 'user', 'monitor', 'billing'] },
  { name: '로그아웃', url: '/logout', icon: 'fas fa-sign-out-alt', permissions: ['owner', 'user', 'monitor', 'billing'] },
]

// let check_permit = vs => _.filter(vs, v => {
//   if(!auth.has_level(v.level)) { return undefined; }
//   if(_.isArray(v.children)) { v.children = check_permit(v.children); }
//   return v;
// });

export default {
  components: {
    Language,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  // data: () => ({ nav: check_permit(links), pause: false, stale: undefined, stale_check : undefined }),
  data: () => {
    return {
      show : true,
      custom : Custom.custom_default,
      // WMDS : WMDS,
      // WSFinder : WSFinder,
      // WEBCastle : WEBCastle,
      // WFDetector : WFDetector,
      // Owner_nav : Owner_nav,
      // User_nav: User_nav,
      auth,
      allow_solution_dashboard : false,
      // s: '',
      base_href : `${location.protocol}//${location.host}`,
      // b : undefined,
      pause: false,
      location : 'welcome',
      service : '',
      stale: undefined,
      stale_check : undefined,
      alert: false,
    }
  },
  computed: {
    is_custom() {
      return this.custom && this.custom.slogan && this.custom.slogan.toUpperCase().indexOf('F1-UWSS') < 0
    },
    i18n_data() { return _i18n_data; },
    name() { return this.$route.name },
    list() { return this.$route.matched },
    nav_ko() {
      if(!this.auth.profile.permissions) { return [] }
      let nav_rt = []

      // 계정 권한 확인
      OwnerManage_ko.forEach(r =>
        _.indexOf(r.permissions, this.auth.profile.permissions) > -1 && (
          r.name != '요금' || (r.name.startsWith('요금') && !this.auth.license.onPremise)
        ) ? nav_rt.push(r) : ''
      )
      BaseManage_ko.forEach(r => {
        if(r.url && r.url.indexOf('download') > -1 && !(this.auth.license.WEBCastle.use || this.auth.license.WSFinder.use)) { return }

        if(r.url && r.url.indexOf('welcome') > -1 && this.auth.license.WEBCastle.use && !this.auth.license.WSFinder.use && !this.auth.license.WMDS.use) {
          r.url = '/webcastle/dashboard'
        }

        if(r.url && r.url.indexOf('welcome') > -1 && this.auth.license.WSFinder.use && !this.auth.license.WEBCastle.use && !this.auth.license.WMDS.use) {
          r.url = '/wsfinder/dashboard'
        }

        if(r.url && r.url.indexOf('welcome') > -1 && this.auth.license.WMDS.use && !this.auth.license.WSFinder.use && !this.auth.license.WEBCastle.use) {
          r.url = '/wmds/dashboard'
        }

        _.indexOf(r.permissions, this.auth.profile.permissions) > -1 ? nav_rt.push(r) : ''
      })

      // 솔루션
      // 1. 사용 여부 확인
      // 2. 권한 확인
      this.auth.profile.permissions != '요금' ? nav_rt.push({ name: '보안 설정', title : true })  : ''

      _.filter(_.concat(WEBCastle_ko, WSFinder_ko, WMDS_ko, WFDetector_ko), r => {
        let check = _.indexOf(r.permissions, this.auth.profile.permissions) > -1 &&
        (
          (r.name.toLowerCase() == 'webcastle' && this.auth.license.WEBCastle.use) ||
            (r.name.toLowerCase() == 'wsfinder' && this.auth.license.WSFinder.use) ||
              (r.name.toLowerCase() == 'wmds' && this.auth.license.WMDS.use) ||
                (r.name.toLowerCase() == 'wfdetector' && this.auth.license.WFDetect.use)
        )
        if(check) {
          // 라이선스별 사용 솔루션 표시해줘야함
          // if(r.title) { r.badge = { text: 'sss', variant:"dark" } }
          return r
        }
      }).forEach(r => nav_rt.push(r))

      // 게시판
      this.auth.profile.permissions != 'billing' ? Board_ko.forEach(r => nav_rt.push(r)) : ''

      // 나의 정보
      Profile_ko.forEach(r => nav_rt.push(r))

      return nav_rt;
    },
    nav_en() {
      if(!this.auth.profile.permissions) { return [] }
      let nav_rt = []

      // 계정 권한 확인
      OwnerManage.forEach(r =>
        _.indexOf(r.permissions, this.auth.profile.permissions) > -1 && (
          r.name.toLowerCase() != 'billing' || (r.name.toLowerCase().startsWith('billing') && !this.auth.license.onPremise)
        ) ? nav_rt.push(r) : ''
      )
      BaseManage.forEach(r => {
        if(r.url && r.url.indexOf('download') > -1 && !(this.auth.license.WEBCastle.use || this.auth.license.WSFinder.use)) { return }

        if(r.url && r.url.indexOf('welcome') > -1 && this.auth.license.WEBCastle.use && !this.auth.license.WSFinder.use && !this.auth.license.WMDS.use) {
          r.url = '/webcastle/dashboard'
        }

        if(r.url && r.url.indexOf('welcome') > -1 && this.auth.license.WSFinder.use && !this.auth.license.WEBCastle.use && !this.auth.license.WMDS.use) {
          r.url = '/wsfinder/dashboard'
        }

        if(r.url && r.url.indexOf('welcome') > -1 && this.auth.license.WMDS.use && !this.auth.license.WSFinder.use && !this.auth.license.WEBCastle.use) {
          r.url = '/wmds/dashboard'
        }

        _.indexOf(r.permissions, this.auth.profile.permissions) > -1 ? nav_rt.push(r) : ''
      })

      // 솔루션
      // 1. 사용 여부 확인
      // 2. 권한 확인
      this.auth.profile.permissions != 'billing' ? nav_rt.push({ name: 'Security Setting', title : true })  : ''

      _.filter(_.concat(WEBCastle, WSFinder, WMDS, WFDetector), r => {
        let check = _.indexOf(r.permissions, this.auth.profile.permissions) > -1 &&
        (
          (r.name.toLowerCase() == 'webcastle' && this.auth.license.WEBCastle.use) ||
            (r.name.toLowerCase() == 'wsfinder' && this.auth.license.WSFinder.use) ||
              (r.name.toLowerCase() == 'wmds' && this.auth.license.WMDS.use) ||
                (r.name.toLowerCase() == 'wfdetector' && this.auth.license.WFDetect.use)
        )
        if(check) {
          // 라이선스별 사용 솔루션 표시해줘야함
          // if(r.title) { r.badge = { text: 'sss', variant:"dark" } }
          return r
        }
      }).forEach(r => nav_rt.push(r))

      // 게시판
      this.auth.profile.permissions != 'billing' ? Board.forEach(r => nav_rt.push(r)) : ''

      // 나의 정보
      Profile.forEach(r => nav_rt.push(r))

      return nav_rt;
    },
  },
  methods: {
    refresh_active(redirect) {
      document.getElementsByClassName('nav-item').forEach(e => {
        // console.log(this.$route, redirect, e.dataset.name, redirect.endsWith(e.dataset.name), redirect.endsWith(this.$route.name))
        if(!e.dataset.name || this.$route.path == redirect) {
          return e.className = 'nav-item'
        }

        e.className = redirect.startsWith(e.dataset.name) ? 'nav-item active' : 'nav-item'

        if(!e.className.endsWith('active'))  { return }

        this.$router.push(redirect)
      })
    },
    get_year() { return new Date().getFullYear() },
    manual() {
      // console.log('lang', this.i18n)
      // http://[domain]/downloads/manual/[파일명, ex, f1-uwss.en.front.manual.latest.pdf) ]
      // en, ko 는 언어에 따라 구분되어야 합니다

      if(localStorage['UWSS_LANG'] == 'JP') {
        return this.alert = true;
      }

      return window.open(this.custom.manual ? this.custom.manual : `https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual.replace('en', this.i18n.toLowerCase())}`)
      // if(auth.profile && auth.profile.language) {
      //   return window.open(this.custom.manual ? this.custom.manual : `https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual.replace('en', auth.profile.language ? auth.profile.language.toLowerCase() : '')}`)
      // } else {
      //   return window.open(this.custom.manual ? this.custom.manual : `https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual.replace('en', this.i18n.toLowerCase() == 'ko' ? 'ko' : this.i18n)}`)
      // }
    },
    // menual() { return window.open(this.custom.manual ? this.custom.manual : `https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}`) },
    // menual() { return window.open(`https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}`) },
    toggle() { this.pause = !this.pause; this.pause ? idle.pause() : idle.resume(); },
    logout() { auth.logout();  this.$router.push('/login') },

    //support 로 리다이렉션 및 이동
    support(){
      return window.open(`http://support.f1security.co.kr/login`)
    }
  },
  created: function() {
    this.allow_solution_dashboard = (this.auth.profile.permissions != 'billing')
    this.custom = Custom.setting();
    console.info('[vue] private container', 'created');
    this.timeout = this.auth.profile.timeout ? Number(this.auth.profile.timeout) : 15 * 60
    // 자동 타임아웃
    idle.start(this.logout, 5 + (this.timeout / 60)) // 지정 시간 로그아웃, 5 분 이후부터 적용
      .keepalive(auth.refresh, 300); // 5 분 (sec) 마다 토큰 검증

    signalr.start('ws')
      .on('msg', m => this.$toastr.s(m.body ? m.body : m, 'Message'))
      .on('emsg', m => this.$toastr.w(m, 'Message'))
      .on('err', m => console.error(m))
      .on('error', m => console.error(m))
      .on('wmds', m => signalr.publish('wmds', m))
      // .on('wsfinder', m => signalr.publish('wsfinder_response', m)) // 응답용
      .on('wsfinder', m => signalr.publish('wsfinder', m))
      .on('webcastle', m => signalr.publish('webcastle', m))
      .on('forgery', m => this.$toastr.w(m.body ? m.body : m, 'Forgery Detect'))
      .on('logout', m => { this.$toastr.s(m.body ? m.body : m, 'Message'); this.nav = ''; this.logout(); })

    this.stale_check = setInterval((timeout=this.timeout) => {
      if(idle.p) { return this.stale = '∞'; }

      let ts = parseInt((idle.stale - new Date().getTime()) / 1000);
      if(ts > this.timeout) { return this.stale = `+${timeout < 60 ? 0 : Math.floor( timeout / 60)}:${(timeout % 60).toString().padStart(2, '0')}`; } // 5분 이내는 신경쓰지 않음.
      let m = (parseInt(ts / 60)).toString();
      let s = (parseInt(ts % 60) + 100).toString().substr(1,2);
      return this.stale = `${m}:${s}`;
    }, 1000);
  },
  destroyed: function() {
    console.info('[vue] private container', 'destroyed');
    signalr.stop();
    idle.stop();
    clearInterval(this.stale_check);
    this.stale_check = []
  },
  mounted: function() {
    console.log('[vue] private container', 'mounted');

    const plugin = document.createElement("script");
    plugin.setAttribute("src", "/F1C/assets/js/atlantis.min.js");
    plugin.async = true
    document.head.appendChild(plugin)
  },
}
